<div class="loader-container">
    <div class="fxs-progress">
        <div class="fxs-progress-dots">
            <div></div><div></div><div></div>
            <div class="loader-message">{{message}}</div>
        </div>
    </div>
</div>